import { Prono } from '../domains/courses/services/type';

const SCORE_THRESHOLD_CRACK = 7; // vraiment excellent
const SCORE_THRESHOLD_BASE = 6; // solide
const SCORE_THRESHOLD_OUTSIDER_MIN = 5; // solide
const COTE_CRACK_MAX = 3;
const COTE_BASE_MAX = 12;
const COTE_OUTSIDER_MIN = 12;
const getProbaImplicite = (cote: number): number => Math.min(1, 3 / cote) * 100;

export const isCrack = (prono: Prono): boolean =>
    (prono.data.coteDirect || 999) <= COTE_CRACK_MAX &&
    (prono.total || 0) >= SCORE_THRESHOLD_CRACK;

export const isBase = (prono: Prono): boolean =>
    (prono.data.coteDirect || 999) < COTE_BASE_MAX &&
    !isCrack(prono) &&
    (prono.total || 0) >= SCORE_THRESHOLD_BASE;

export const isOutsider = (prono: Prono): boolean => {
    const cote = prono.data.coteDirect || 0;
    const probaImplicite = getProbaImplicite(cote);
    return (
        cote >= COTE_OUTSIDER_MIN && prono.total >= 5
    );
};
